const lang = {
  ja: "日本語",
  en: "English",
};

export default lang;
